import { render } from "./Lista.vue?vue&type=template&id=a9379c20&scoped=true&ts=true"
import script from "./Lista.vue?vue&type=script&lang=ts"
export * from "./Lista.vue?vue&type=script&lang=ts"

import "./Lista.vue?vue&type=style&index=0&id=a9379c20&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9379c20"]])

export default __exports__